import {getBorrowCollateralPositionStyling} from '#/utils/borrow-utils';
import {ClassName} from '#/utils/utils';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
  percentage: number;
};
export const DotPercentageCollateralPositionIndicator: FunctionComponent<Props & ClassName> = ({
  className,
  percentage,
}) => {
  const {t} = useTranslation('translation');
  const style = getBorrowCollateralPositionStyling(percentage);

  return (
    <span className={`flex items-center gap-1 ${style.color} ${className}`}>
      <span className={`w-2 h-2 rounded-full ${style.bg}`} />
      {t('utils.percentageFixed', {
        value: percentage,
      })}
    </span>
  );
};
